import { useCallback } from 'react'
import { ReactFCC } from '@/types/react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'
import { TorchApplicationPresentationType } from '../../components/TorchApplicationContext'

interface PresentationTypesProps {
  disabled?: boolean
  value?: TorchApplicationPresentationType
  onChange: ({ name, value }: { name: string; value: string }) => void
  name: string
}

export const PresentationTypes: ReactFCC<PresentationTypesProps> = ({ disabled, name, value, onChange }) => {
  const { t } = useTranslate('guild-create')

  const options = [
    {
      label: t('presentationLiveAction', 'Live Action'),
      value: TorchApplicationPresentationType.LiveAction,
    },
    {
      label: t('presentationAnimation', 'Animation'),
      value: TorchApplicationPresentationType.Animation,
    },
    {
      label: t('presentationAnimatic', 'Animatic'),
      value: TorchApplicationPresentationType.Animatic,
    },
  ]

  const handleChange = useCallback(
    (value: string[]) => {
      const [presenatationTypeValue] = value
      onChange({ name, value: presenatationTypeValue })
    },
    [name, onChange],
  )

  return (
    <OptionGroup
      name="presentationType"
      label={t('presentationType', 'Presentation Type')}
      options={options}
      required
      disabled={disabled}
      value={value ? [value] : []}
      onChange={handleChange}
      limit={1}
    />
  )
}
